export default {
	methods: {
		firstTabHandler(e) {
			if (e.shiftKey) {
				e.preventDefault();
				this.$refs.lastTabbable.focus();
			}
		},
		lastTabHandler(e) {
			if (!e.shiftKey) {
				e.preventDefault();
				this.$refs.firstTabbable.focus();
			}
		}
	}
};
